import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/make-legs-longer"
    exact
    path="/consumer/features/make-legs-longer"
    component={AsyncPage}
  />,
];
